export const home = {
  hero: {
    title: 'DR Group GmbH',
    subtitle: 'Holding de inversiones y gestión de activos propios',
    intro: 'Mantenemos y gestionamos inversiones en nuestro propio nombre y por nuestra propia cuenta. No prestamos servicios a terceros.',
    viewStructure: 'Ver estructura',
    contact: 'Contacto'
  },
  tiles: {
    investments: {
      title: 'Inversiones',
      description: 'Mantenimiento y gestión de participaciones accionarias en nuestro propio nombre y por nuestra propia cuenta.'
    },
    assetManagement: {
      title: 'Gestión de Activos',
      description: 'Gestión profesional de activos propios con enfoque en creación de valor a largo plazo.'
    },
    governance: {
      title: 'Gobernanza',
      description: 'Supervisión estructurada y gobierno corporativo de nuestras participaciones.'
    }
  }
};
